import React from 'react'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessFullScreen from 'app/auth/PaidPlanAccessFullScreen'
import NewTeamMembers from 'app/main/settings/teamMembersV4/TeamMembers'

const TeamMembers = () => {
  return (
    <PaidPlanAccess freePlanComponent={<PaidPlanAccessFullScreen />}>
      <NewTeamMembers />
    </PaidPlanAccess>
  )
}

export default TeamMembers
